<!-- eslint-disable vue/no-v-html -->
<template>
  <CustomTable
    :columns="tableFields"
    :draggable="true"
    :is-loading="isReordering"
    :data="tableData"
    :height-tb="true"
    :empty-text="emptyText"
    :reorderable="true"
    :header-wrapper-class="'tw-bg-[#fcfcfd]'"
    :id-item-expland="idItemExpland"
    @moved="reorderList"
    @update-selected-rows="handleSelectTemplate($event)"
  >
    <template #cell(name)="data">
      <div class="information-container tw-flex tw-items-center">
        <img
          v-if="data.value?.imgSrc"
          :src="data.value?.imgSrc"
          alt="person_random"
        />
        <div
          class="information tw-font-[13px] tw-flex tw-mr-12 tw-items-center tw-gap-2"
        >
          <span
            style="
              color: #231f20;
              font-size: 13px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            "
            class="name-value"
            >{{ data.value }}</span
          >
        </div>
      </div>
    </template>
    <template #cell(templateDescription)="data">
      <div class="information-container tw-flex tw-items-center">
        {{ data.value }}
      </div>
    </template>
    <template #cell(templateType)="data">
      <div
        class="tw-w-full tw-items-center tw-justify-center tw-inline-flex tw-gap-2"
      >
        <div class="tw-relative">
          <StatusBadge
            :label="data.value"
            :is-check-plan="
              data.item.templatePlanEntitled || data.item.templateOrgId !== null
            "
            :is-template-org="data.item.templateOrgId !== null"
            :class-current-user="'tw-text-[#387dff] tw-leading-[130%] tw-bg-white tw-border tw-border-solid tw-border-[#e4f1ff] tw-rounded-[5px] tw-text-[13px] tw-font-[500]'"
            :value="data.value"
          />
          <span class="tw-absolute">
            <ButtonShowDuplicateAssessment
              v-if="!data.item.templatePlanEntitled"
              :id-popover="'popover' + Math.random() * 1000"
              :custom-class="'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px] '"
              :classes="`!tw-leading-none tw-ml-2`"
            >
              <div class="tw-p-[15px]">
                <div class="tw-text-[14px] tw-font-[500] tw-text-[#211F58]">
                  {{
                    getComponentUiText(
                      "app-assess-assessment-manage-template-modal-title-tooltip-plan-1",
                    )
                  }}
                </div>
                <div
                  class="tw-py-[10px] tw-text-[13px] tw-font-[400] tw-text-[#878787]"
                  @click="routerSubscription"
                  v-html="descriptionTemplate"
                ></div>
              </div>
            </ButtonShowDuplicateAssessment>
          </span>
        </div>
      </div>
    </template>

    <template #cell(itemCount)="data">
      <div
        v-if="isLoadingTemplateDetail && data.item.id === idItemExpland"
        class="custom-global-skeleton tw-w-full tw-h-[20px]"
      ></div>
      <div
        v-else
        style="
          color: var(--UI-dark-grey, #878787);
          text-align: center;
          font-family: Poppins;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        "
        class="tw-w-full tw-items-center tw-justify-center tw-inline-flex"
      >
        {{ data.item.itemCount }}
      </div>
    </template>

    <template #cell(action)="data">
      <popoverAssessment
        v-if="data.item.templatePlanEntitled"
        style-button="!tw-py-[10px] !tw-px-[10px] tw-ml-[-10px] tw-mr-[-10px] tw-items-center tw-justify-center"
        :offset="20"
        :id-popover="'popover-manage-template-table-' + data.item.id"
      >
        <template #header>
          <div
            style="
              letter-spacing: 1.2px;
              text-transform: uppercase;
              font-family: Poppins;
            "
            class="tw-text-[12px] tw-text-[#211F58] tw-font-semibold tw-px-[13px] tw-pt-[17px] tw-pb-[25px]"
          >
            {{ getComponentUiText("app-menu-submenu-settings-1") }}
          </div>
        </template>
        <CustomDropDownItem
          v-for="(item, index) in items"
          :key="`option_template_${index}`"
          :id-text="`${item.text}`"
          :custom-text-class="`tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
            item.arrowRed ? 'tw-text-[#F7553C]' : ''
          } tw-whitespace-normal`"
          :arrow-icon-style="`${
            item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
          } tw-min-w-[7px]`"
          :padding="'tw-px-[13px] tw-py-[12px]'"
          :custom-class="'tw-flex tw-justify-between tw-items-center !tw-border-0'"
          @click="() => item.action(data.item)"
        />
      </popoverAssessment>
    </template>
    <template #cell(expland)="data">
      <ArrowDownTableIcon
        :class="[
          data.item.id === idItemExpland ? 'show' : '',
          'tw-cursor-pointer',
        ]"
        @click="
          (idItemExpland =
            idItemExpland === data.item.id ? null : data.item.id),
            idItemExpland === data.item.id
              ? getTemplateDetail(data.item.templateId)
              : null
        "
      />
    </template>
    <template #detail="">
      <div
        v-if="isLoadingTemplateDetail"
        class="custom-global-skeleton tw-w-full tw-h-[73px]"
      ></div>
      <ManageTemplateCatergoryItem
        v-for="(item, index) in listTemplateDetail.categoryDetails"
        v-else
        :key="index"
        :data="item"
        :index="index"
      />
    </template>
  </CustomTable>
</template>

<script lang="ts" setup>
import { computed, Ref, ref, watch } from "vue";
import CustomTable from "@/components/common/customTable.vue";
import popoverAssessment from "@/components/assessment/popoverAssessment.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import StatusBadge from "../common/setting/statusBadge.vue";
import store from "@/store";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import ManageTemplateCatergoryItem from "./manageTemplateCatergoryItem.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Subscription } from "@/services/apiRoutes/routes";
import { getSessionPortal } from "@/services/subscriptions";
import CustomDropDownItem from "../common/customDropDownItem.vue";

export type dataActionTableColumn = {
  id: any;
  title: string;
  scoreIncreaseTotal: number;
  scoreIncreaseFirstCount: number;
  riskReduction: "High" | "Significant";
};
const props = defineProps({
  dataRow: {
    type: Array as () => dataActionTableColumn[],
    required: true,
    default: () => [],
  },
  tableData: {
    type: Array as () => any[],
    default: () => [],
  },
  tableFields: {
    type: Array as () => any[],
    default: () => [],
  },
  emptyText: {
    type: String,
    default: "",
  },
});

const handleDeleteAssessment = (item: any) => {
  emit("delete:assessment", item);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleCreateAssessment = (item: any) => {
  emit("create:assessment", item);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleSelectTemplate = (selectedIds: number[]) => {
  const data = selectedIds.map((id) =>
    props.tableData.find((item) => item.id === id),
  );
  emit("select:row", data);
};

const items = [
  {
    text: "app-assess-assessment-modal-start-assessment-1",
    arrowRed: false,
    action: handleCreateAssessment,
  },
  {
    text: "app-assess-assessment-modal-delete-template-title-1",
    arrowRed: true,
    action: handleDeleteAssessment,
  },
];
const dataTable = ref(props.dataRow);
const isReordering: any = ref(false);
const idItemExpland = ref(null);
const isLoadingTemplateDetail = ref(false);
const descriptionTemplate: any = ref(
  getComponentUiText(
    "app-assess-assessment-manage-template-modal-description-tooltip-plan-1",
    false,
    {
      linkText: getComponentUiText(
        "app-assess-assessment-manage-template-modal-btn-click-here-1",
      ),
    },
    true,
  ),
);

const routerSubscription = async (event) => {
  if (event.target.id === "upgrade-link") {
    event.preventDefault();
    try {
      {
        const clientSecretResponse = await getSessionPortal("dashboard");
        const sessionPortalUrl =
          clientSecretResponse.data?.data?.redirectUrl || "";
        window.open(sessionPortalUrl, "_blank");
        if (!sessionPortalUrl) {
          showErrorAPI("app-settings-subscription-error-text-1", "error");
          return;
        }
        return;
      }
    } catch (error) {
      // showErrorAPI(error, Subscription.getSessionPortal);
    }
  }
};

const emit = defineEmits([
  "update-selected-rows",
  "select:row",
  "delete:assessment",
  "create:assessment",
]);

const listTemplateDetail = computed(
  () => store.getters["Assessment/getListTemplateDetail"],
);

const reorderList = async (data) => {
  isReordering.value = true;

  store.commit("Assessment/REORDER_LIST_TEMPLETE", data);

  setTimeout(async () => {
    isReordering.value = false;
  }, 500);
};

const getTemplateDetail = async (id: number) => {
  // store.commit("Assessment/UPDATE_TOTAL_COUNT_TEMPLATE", {});
  isLoadingTemplateDetail.value = true;

  await store.dispatch("Assessment/getTemplateDetail", id);

  isLoadingTemplateDetail.value = false;
};

watch(
  () => props.dataRow,
  () => {
    dataTable.value = props.dataRow;
  },
);
</script>

<style lang="scss" scoped>
.show {
  transform: rotate(180deg);
}
.title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 16.9px */
  margin-right: 4px;
}
.score-title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.content__settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Poppins;
  line-height: 135%;
  cursor: pointer;
}
</style>
